import { Component, Input, OnInit } from '@angular/core';
import { MdrDashboardsService } from '../../../services/mdr-dashboards.service';
import { OrganizationsService } from '../../../../organizations/services/organizations.service';

export enum XDRAlertEnum {
    CLOUD = 'cloud',
    NETWORK = 'network',
    PRODUCTIVITY = 'productivity_apps',
    IDENTITY_PROVIDERS = 'identity_provider',
}

@Component({
    selector: 'app-mdr-checks-indicator',
    templateUrl: './mdr-checks-indicator.component.html',
    styleUrls: ['./mdr-checks-indicator.component.scss'],
    standalone: false,
})
export class MdrChecksIndicatorComponent implements OnInit {
    @Input() element: any;
    /* @var defaultEmptyValue - what to show on empty/error state */
    @Input() defaultEmptyValue = {
        xdr: {
            network: false,
            productivity_apps: false,
            identity_provider: false,
            cloud: false,
        },
    };
    public isLcoCompany: boolean;

    constructor(private mdrDashboardsService: MdrDashboardsService, private organizationService: OrganizationsService) {}

    /**
     * Function to check if the object is empty or not
     * @param obj - object to check
     */
    public isEmptyObject(obj: {} | null) {
        if (!obj) {
            return true;
        }

        return obj && Object.keys(obj).length === 0;
    }

    /**{ [key: string]: boolean }*/
    public hasAtLeastOneXdr(widget: any) {
        if (widget.data) {
            const arrayOfKeys = this.returnArrayOfKeys(widget.data?.data);
            const hasOneXdrActive = arrayOfKeys.filter((x) => widget.data.data[x] === true);
            return hasOneXdrActive.length > 0;
        }

        if (widget.error) {
            return false;
        }
        return !widget.data;
    }

    public getXdrName(xdr: XDRAlertEnum) {
        switch (xdr) {
            case XDRAlertEnum.CLOUD:
                return 'XDR Cloud';
            case XDRAlertEnum.NETWORK:
                return 'XDR Network';
            case XDRAlertEnum.PRODUCTIVITY:
                return 'XDR Productivity';
            case XDRAlertEnum.IDENTITY_PROVIDERS:
                return 'XDR Identity';
        }
    }

    public returnArrayOfKeys(widgetData: any) {
        return Object.keys(widgetData) as unknown as XDRAlertEnum[];
    }

    public getXdrIcon(xdr: XDRAlertEnum) {
        switch (xdr) {
            case XDRAlertEnum.CLOUD:
                return 'ds-icon-XDR_cloud';
            case XDRAlertEnum.NETWORK:
                return 'ds-icon-XDR_network';
            case XDRAlertEnum.PRODUCTIVITY:
                return 'ds-icon-XDR_productivity';
            case XDRAlertEnum.IDENTITY_PROVIDERS:
                return 'ds-icon-XDR_identity';
        }
    }

    ngOnInit(): void {
        this.organizationService.selectedOrganization$().subscribe((org) => {
            this.isLcoCompany = this.mdrDashboardsService.isLcoCompany(org);
        });
    }
}
